import { fields, createSchema, validate as _validate } from '..';

const { goalsArrayAtLeastOne } = fields;

const schema = createSchema({
  personalGoals: goalsArrayAtLeastOne,
});

const validate = (data) => {
  return _validate(schema, data);
};

export default validate;
